import type { VaultSpaceLocalAttribute } from "#common/graphql/Attribute";
import type {
  AttrDataType,
  Space,
  SpaceLocalAttribute,
  VaultDomain,
} from "#common/types/vault";

export const isSelectType = (dt: AttrDataType): boolean =>
  dt === "Single-select" || dt === "Multi-select";

/** The "Value set" column summary for a space-local attribute. */
export const localSummary = (l: SpaceLocalAttribute): string => {
  if (isSelectType(l.dataType))
    return l.options && l.options.length ? l.options.join(" · ") : "—";
  if (l.dataType === "Yes/No") return "Yes · No";
  return "—";
};

export const domainName = (id: string, domains: VaultDomain[]): string =>
  domains.find((d) => d.id === id)?.name ?? id;

/**
 * Build a minimal `Space` around one server-returned space-local attribute
 * row, for the edit/promote modals — they take a `Space` for display and for
 * their own-space name-conflict check, but a cross-space search row only
 * carries its OWN space's id/name/domain, not every local that space holds.
 * `locals` therefore holds only the attribute being acted on: enough for the
 * conflict check (which excludes the attribute itself via `ignoreLocalId`
 * anyway), and final uniqueness is still enforced server-side on save.
 */
export const spaceFromLocalRow = (row: VaultSpaceLocalAttribute): Space => ({
  id: row.spaceId,
  name: row.spaceName,
  domain: row.domain,
  contract: {
    permission: "",
    quality: "guaranteed",
    qualityNote: "",
    lifecycle: "",
    ingest: "Manual",
    channel: null,
  },
  globals: {},
  locals: [row.local],
});
